'use strict'

const Base = require('../base.edit')
const modal = new (require('../../helpers/modal'))
const forms = new (require('../../helpers/forms'))

module.exports = class timeCountdownWidget extends Base {

	onInit() {

		let sDate = new Date(this._data.date || Date.now())
		this._input = document.createElement('input')
		this._input.type = 'datetime-local'
		this._input.value = `${sDate.getFullYear()}-${(sDate.getMonth() +1).toString().padStart(2, "0")}-${sDate.getDate().toString().padStart(2,"0")}T${sDate.getHours().toString().padStart(2,"0")}:${sDate.getMinutes().toString().padStart(2,"0")}`
		this._input.addEventListener('blur', () => {
			this._data.date = new Date(this._input.value).getTime()
		})
		this._widget.appendChild(this._input)
		this._input.focus()

		this._widget.querySelector(".view").style['display'] = 'none'
	}

	onDestroy() {
		if (this._input) {
			this._input.remove()
		}
		this._widget.querySelector(".view").style['display'] = 'initial'
		this._input = null
	}

	onSave() {
		window.location.reload()
	}

	generateOptionsForm() {
		let block = document.createElement('div')
		block.className = 'form-block'
		let wrapper = document.createElement('div')
		wrapper.className = 'form-wrapper'
		let div = document.createElement('div')
		div.className = 'form-group'

		let text = document.createElement('input')
		text.value = new Date(this._data.date || Date.now()).toISOString().slice(0, -8)

		text.type = 'datetime-local'
		div.appendChild(forms.input('Text', text))


		wrapper.appendChild(div)
		block.appendChild(wrapper)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Odoslať'
		button.onclick = () => {
			this._data.date = Date.parse(text.value + 'Z')
			this._render()
			modal.hide()
		}
		block.appendChild(forms.actions(button))

		let title = 'Nastavenia'
		modal.show(title, block).then(() => { text.focus() })

	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/time-countdown/time-countdown.edit.js
// module id = 500
// module chunks = 0